export const GAME_VERSION = '0.107';
export const BACKWARDS_COMPATIBILITY_VERSION = '0.107';

// State machine constants
export const IDLE = 'IDLE';
export const CHANGE_DIRECTION = 'CHANGE_DIRECTION';
export const START_MOVING = 'START_MOVING';
export const MOVING = 'MOVING';
export const END_MOVING = 'END_MOVING';
export const COLLISION = 'COLLISION';
export const START_BATTLE = 'START_BATTLE';
export const BATTLE = 'BATTLE';
export const END_BATTLE = 'END_BATTLE';
export const EVOLVE_POKEMON = 'EVOLVE_POKEMON';
export const USE_KEYBOARD = 'USE_KEYBOARD';
export const READ_TEXT_SOURCE = 'READ_TEXT_SOURCE';
export const PAUSE_MENU = 'PAUSE_MENU';
export const OPTIONS_MENU = 'OPTIONS_MENU';
export const POKEDEX = 'POKEDEX';
export const POKEMON = 'POKEMON';
export const SWITCH_POSITIONS_WITH_WHO = 'SWITCH_POSITIONS_WITH_WHO';
export const POKEMON_SWITCH_POSITIONS = 'POKEMON_SWITCH_POSITIONS';
export const POKEMON_SUMMARY = 'POKEMON_SUMMARY';
export const POKEMON_MOVE_DETAIL = 'POKEMON_MOVE_DETAIL';
export const POKEMON_PRESELECTED = 'POKEMON_PRESELECTED';
export const BAG = 'BAG';
export const BAG_ITEM_PRESELECTED = 'BAG_ITEM_PRESELECTED';
export const SELECT_ITEM_RECIPIENT = 'SELECT_ITEM_RECIPIENT';
export const SELECT_ITEM_CONSUMER = 'SELECT_ITEM_CONSUMER';
export const APPLY_ITEM_TO_RECIPIENT = 'APPLY_ITEM_TO_RECIPIENT';
export const APPLY_EV_ITEM_TO_RECIPIENT = 'APPLY_EV_ITEM_TO_RECIPIENT';
export const ITEM_GIVEN_TO_POKEMON = 'ITEM_GIVEN_TO_POKEMON';
export const ITEM_TAKEN_FROM_POKEMON = 'ITEM_TAKEN_FROM_POKEMON';
export const DO_WHAT_WITH_ITEM = 'DO_WHAT_WITH_ITEM';
export const SELECT_ITEM_CONSUMER_MOVE = 'SELECT_ITEM_CONSUMER_MOVE';
export const SAVE = 'SAVE';
export const EXIT = 'EXIT';
export const INTERACTING = 'INTERACTING';
export const SEEN_BY_TRAINER = 'SEEN_BY_TRAINER';
export const PLAYER_SEEN = 'PLAYER_SEEN';
export const MOVE_N_STEPS = 'MOVE_N_STEPS';
export const APPROACHED_PLAYER = 'APPROACHED_PLAYER';
export const APPROACHED_BY_TRAINER = 'APPROACHED_BY_TRAINER';
export const TRAINER_BATTLE_INTRO = 'TRAINER_BATTLE_INTRO';
export const START_TRAINER_BATTLE = 'START_TRAINER_BATTLE';
export const ACQUIRE_OVERWORLD_ITEM = 'ACQUIRE_OVERWORLD_ITEM';
export const INTERACT_WITH_HM_TREE = 'INTERACT_WITH_HM_TREE';
export const INTERACT_WITH_HM_ROCK = 'INTERACT_WITH_HM_ROCK';
export const WARP_TO_LOCATION = 'WARP_TO_LOCATION';
export const INTERACT_WITH_HEALING_LOCATION = 'INTERACT_WITH_HEALING_LOCATION';
export const INTERACT_WITH_MART_LOCATION = 'INTERACT_WITH_MART_LOCATION';
export const APPLY_HM_TO_RECIPIENT = 'APPLY_HM_TO_RECIPIENT';
export const APPLY_ITEM_TO_MOVE = 'APPLY_ITEM_TO_MOVE';
export const CONFIRM_LEARN_NEW_MOVE = 'CONFIRM_LEARN_NEW_MOVE';
export const CHOOSE_MOVE_TO_FORGET = 'CHOOSE_MOVE_TO_FORGET';
export const STOP_LEARNING_NEW_MOVE = 'STOP_LEARNING_NEW_MOVE';
export const DID_NOT_LEARN_NEW_MOVE = 'DID_NOT_LEARN_NEW_MOVE';
export const LEARNED_NEW_MOVE = 'LEARNED_NEW_MOVE';
export const FORGOT_MOVE = 'FORGOT_MOVE';
export const IT_WONT_HAVE_ANY_EFFECT = 'IT_WONT_HAVE_ANY_EFFECT';
export const MOVE_ITEM_APPLIED = 'MOVE_ITEM_APPLIED';
export const HEALTH_ITEM_APPLIED = 'HEALTH_ITEM_APPLIED';
export const EV_ITEM_APPLIED = 'EV_ITEM_APPLIED';
export const TRAINER_CARD = 'TRAINER_CARD';
export const CHOOSE_MART_OPTION = 'CHOOSE_MART_OPTION';
export const CANT_SELL_THIS_ITEM = 'CANT_SELL_THIS_ITEM';
export const BUY_FROM_MART = 'BUY_FROM_MART';
export const SELL_TO_MART = 'SELL_TO_MART';
export const END_MART_INTERACTION = 'END_MART_INTERACTION';
export const CHOOSE_AMOUNT_TO_BUY = 'CHOOSE_AMOUNT_TO_BUY';
export const MART_OPTION_PRESELECTED = 'MART_OPTION_PRESELECTED';
export const MART_OPTION_SELECT_AMOUNT = 'MART_OPTION_SELECT_AMOUNT';
export const MART_ITEM_AMOUNT_SELECTED = 'MART_ITEM_AMOUNT_SELECTED';
export const MART_ITEM_AMOUNT_CONFIRMATION = 'MART_ITEM_AMOUNT_CONFIRMATION';
export const MART_ITEM_AMOUNT_CONFIRMED = 'MART_ITEM_AMOUNT_CONFIRMED';
export const MART_ANYTHING_ELSE = 'MART_ANYTHING_ELSE';
export const MART_NOT_ENOUGH_MONEY = 'MART_NOT_ENOUGH_MONEY';
export const MART_SELL_AMOUNT = 'MART_SELL_AMOUNT';
export const MART_SELL_AMOUNT_CONFIRMATION = 'MART_SELL_AMOUNT_CONFIRMATION';
export const MART_ITEMS_SOLD = 'MART_ITEMS_SOLD';
export const USE_FLASH = 'USE_FLASH';
export const KEY_ITEM_PRESELECTED = 'KEY_ITEM_PRESELECTED';
export const USE_KEY_ITEM = 'USE_KEY_ITEM';
export const TOWN_MAP = 'TOWN_MAP';
export const TOWN_MAP_LOCATION_DETAIL = 'TOWN_MAP_LOCATION_DETAIL';
export const BOOT_UP_PC = 'BOOT_UP_PC';
export const MANAGE_POKEMON = 'MANAGE_POKEMON';
export const MANAGE_POKEMON_WITH_SELECTED = 'MANAGE_POKEMON_WITH_SELECTED';
export const PC_POKEMON_PRESELECTED = 'PC_POKEMON_PRESELECTED';
export const SHUT_DOWN_PC = 'SHUT_DOWN_PC';
export const RELEASE_POKEMON = 'RELEASE_POKEMON';
export const LOAD_GAME = 'LOAD_GAME';
export const LOADING = 'LOADING';
export const OVERWORLD_EVENT = 'OVERWORLD_EVENT';
export const GAME_INTRO = 'GAME_INTRO';
export const SET_PLAYER_NAME = 'SET_PLAYER_NAME';
export const SAVE_FILE_SELECT = 'SAVE_FILE_SELECT';
export const NEW_FILE_STARTED = 'NEW_FILE_STARTED';
export const INTRO_CREDITS = 'INTRO_CREDITS';
export const MOVEMENT_PATTERN = 'MOVEMENT_PATTERN';
export const INTERACT_WITH_NPC = 'INTERACT_WITH_NPC';
export const APPLY_RARE_CANDY = 'APPLY_RARE_CANDY';
export const RARE_CANDY_APPLIED = 'RARE_CANDY_APPLIED';

// Battle Constants
export const WILD_BATTLE_INTRO = 'WILD_BATTLE_INTRO';
export const PRE_BATTLE_SEQUENCE = 'PRE_BATTLE_SEQUENCE';
export const BATTLE_SEQUENCE_PLAYER_MOVE = 'BATTLE_SEQUENCE_PLAYER_MOVE';
export const BATTLE_SEQUENCE_FOE_MOVE = 'BATTLE_SEQUENCE_FOE_MOVE';
export const END_BATTLE_SEQUENCE = 'END_BATTLE_SEQUENCE';
export const TRAINER_WOULD_LIKE_TO_BATTLE = 'TRAINER_WOULD_LIKE_TO_BATTLE';
export const TRAINER_SENDS_OUT_POKEMON = 'TRAINER_SENDS_OUT_POKEMON';
export const TRAINER_SWITCHES_POKEMON = 'TRAINER_SWITCHES_POKEMON';
export const PLAYER_SENDS_OUT_POKEMON = 'PLAYER_SENDS_OUT_POKEMON';
export const CHOOSE_ACTION = 'CHOOSE_ACTION';
export const CHOOSE_MOVE = 'CHOOSE_MOVE';
export const NO_PP_LEFT_FOR_THIS_MOVE = 'NO_PP_LEFT_FOR_THIS_MOVE';
export const FOE_FAINTS = 'FOE_FAINTS';
export const SETUP_EXPERIENCE_GAIN_QUEUE = 'SETUP_EXPERIENCE_GAIN_QUEUE';
export const GAIN_EXPERIENCE_NOTIFICATION = 'GAIN_EXPERIENCE_NOTIFICATION';
export const GAIN_EXPERIENCE_ACTIVE_POKEMON = 'GAIN_EXPERIENCE_ACTIVE_POKEMON';
export const LEVEL_UP_POKEMON = 'LEVEL_UP_POKEMON';
export const NEW_MOVE_AVAILABLE = 'NEW_MOVE_AVAILABLE';
export const CURRENT_MOVES_FULL = 'CURRENT_MOVES_FULL';
export const PLAYER_FAINTS = 'PLAYER_FAINTS';
export const WHITED_OUT = 'WHITED_OUT';
export const END_TRAINER_BATTLE = 'END_TRAINER_BATTLE';
export const RUN_AWAY = 'RUN_AWAY';
export const POKEMON_MENU_BATTLE = 'POKEMON_MENU_BATTLE';
export const CHOOSE_NEXT_POKEMON_QUESTION = 'CHOOSE_NEXT_POKEMON_QUESTION';
export const SWITCHED_TO_SAME_POKEMON = 'SWITCHED_TO_SAME_POKEMON';
export const SWITCHED_TO_FAINTED_POKEMON = 'SWITCHED_TO_FAINTED_POKEMON';
export const POKEMON_SWITCHED_END_OF_TURN = 'POKEMON_SWITCHED_END_OF_TURN';
export const POKEMON_SWITCHED = 'POKEMON_SWITCHED';
export const SUMMARY_MENU_BATTLE = 'SUMMARY_MENU_BATTLE';
export const SUMMARY_MOVE_DETAIL = 'SUMMARY_MOVE_DETAIL';
export const SELECT_MOVE_TO_APPLY_ITEM = 'SELECT_MOVE_TO_APPLY_ITEM';
export const APPLY_ITEM_TO_POKEMON = 'APPLY_ITEM_TO_POKEMON';
export const SELECT_POKEMON_TO_APPLY_ITEM = 'SELECT_POKEMON_TO_APPLY_ITEM';
export const ITEM_APPLIED = 'ITEM_APPLIED';
export const CATCH_POKEMON_ATTEMPT = 'CATCH_POKEMON_ATTEMPT';
export const POKEMON_CAUGHT = 'POKEMON_CAUGHT';
export const ADD_CAUGHT_POKEMON_TO_POKEDEX = 'ADD_CAUGHT_POKEMON_TO_POKEDEX';
export const ASK_FOR_NICKNAME = 'ASK_FOR_NICKNAME';
export const POKEMON_SENT_TO_PC = 'POKEMON_SENT_TO_PC';
export const NICKNAME_INPUT = 'NICKNAME_INPUT';
export const NICKNAME_CONFIRMATION = 'NICKNAME_CONFIRMATION';
export const BAG_MENU = 'BAG_MENU';
export const TRAINER_POKEMON_FORCED_OUT = 'TRAINER_POKEMON_FORCED_OUT';
export const FOE_POKEMON_SENT_OUT_END = 'FOE_POKEMON_SENT_OUT_END';
export const PLAYER_POKEMON_SENT_OUT_END = 'PLAYER_POKEMON_SENT_OUT_END';
export const PLAYER_POKEMON_FORCED_OUT = 'PLAYER_POKEMON_FORCED_OUT';
export const DONT_BE_A_THIEF = 'DONT_BE_A_THIEF';
export const CANT_USE_ITEM = 'CANT_USE_ITEM';
export const CANT_LEAVE_PC_WITHOUT_POKEMON = 'CANT_LEAVE_PC_WITHOUT_POKEMON';
export const SAVE_FILE_INCOMPATIBLE = 'SAVE_FILE_INCOMPATIBLE';
export const SELECT_PLAYER_GENDER = 'SELECT_PLAYER_GENDER';
export const INTERACT_WITH_STATIC_ENCOUNTER = 'INTERACT_WITH_STATIC_ENCOUNTER';
export const SET_NICKNAME = 'SET_NICKNAME';
export const NEW_UNAUTHORIZED_SESSION_STARTED = 'NEW_UNAUTHORIZED_SESSION_STARTED';
export const SET_ACCESS_CODE = 'SET_ACCESS_CODE';
export const VERIFY_ACCESS_CODE = 'VERIFY_ACCESS_CODE';
export const CHECK_AUTH = 'CHECK_AUTH';
export const DARKEN_SCREEN = 'DARKEN_SCREEN';
export const UNDARKEN_SCREEN = 'UNDARKEN_SCREEN';

// Direction constants
export const DOWN = 'down';
export const UP = 'up';
export const LEFT = 'left';
export const RIGHT = 'right';

// Performance constants
export const TARGET_FPS = 100; // Desired frames per second
export const FRAME_DURATION = 1000 / TARGET_FPS; // Duration of each frame in milliseconds
export const ANIMATION_SPEED = 2;
export const SPAWN_SCALE_SPEED = 0.04;

// Item type arrays
export const pokeballItemIDs = ['pokeball', 'great_ball', 'ultra_ball', 'master_ball'];
export const moveItemIDs = ['ether', 'max_ether'];
export const hmIds = ['hm1', 'hm2', 'hm3', 'hm4', 'hm5', 'hm6', 'hm7', 'hm8', 'hm8', 'hm9', 'hm10'];
export const keyItemIds = ['bicycle', 'lunchbox', 'town_map'];
export const heldItemIds = ['miracle_seed', 'charcoal', 'mystic_water', 'poison_barb'];
export const berryItemIds = [
    'cheri_berry', 'chesto_berry', 'pecha_berry', 'rawst_berry', 'aspear_berry',
    'leppa_berry', 'oran_berry', 'persim_berry', 'lum_berry', 'sitrus_berry', 'berry_juice',
    'pomeg_berry', 'kelpsy_berry', 'qualot_berry', 'hondew_berry', 'grepa_berry', 'tamato_berry',
    'liechi_berry', 'ganlon_berry', 'petaya_berry', 'apicot_berry', 'salac_berry',
];
/** Pinch berries: consumed at 25% HP when held, boost one stat by 1 stage. */
export const pinchBerryStat: Record<string, string> = {
    liechi_berry: 'attack',
    ganlon_berry: 'defense',
    petaya_berry: 'specialAttack',
    apicot_berry: 'specialDefense',
    salac_berry: 'speed',
};
export const pinchBerryItemIds = Object.keys(pinchBerryStat);
export const vitaminItemIds = ['hp_up', 'protein', 'iron', 'calcium', 'zinc', 'carbos', 'pp_up', 'pp_max'];

// EV caps
export const EV_TOTAL_MAX = 510;
export const EV_STAT_MAX = 255;
export const EV_VITAMIN_STAT_CAP = 200;

/** EV-increasing vitamins (excludes PP Up / PP Max): item id -> stat key on Pokemon.ev */
export const evVitaminStat: Record<string, string> = {
    hp_up: 'hp',
    protein: 'attack',
    iron: 'defense',
    calcium: 'specialAttack',
    zinc: 'specialDefense',
    carbos: 'speed',
};
export const evVitaminItemIds = Object.keys(evVitaminStat);

/** EV-reducing berries: item id -> stat key on Pokemon.ev */
export const evReducingBerryStat: Record<string, string> = {
    pomeg_berry: 'hp',
    kelpsy_berry: 'attack',
    qualot_berry: 'defense',
    hondew_berry: 'specialAttack',
    grepa_berry: 'specialDefense',
    tamato_berry: 'speed',
};
export const evReducingBerryItemIds = Object.keys(evReducingBerryStat);

/** X items: battle-only items that raise a stat stage by 1. */
export const xItemStat: Record<string, string> = {
    x_attack: 'attack',
    x_defend: 'defense',
    x_speed: 'speed',
    x_special_attack: 'specialAttack',
    x_special_defense: 'specialDefense',
    x_accuracy: 'accuracy',
};
export const xItemIds = Object.keys(xItemStat);
export const battleItemIds = [...xItemIds, 'guard_spec', 'dire_hit'];

// Stage multipliers
export const stageMultiplier = {
    accuracy: {
        [-6]: 33 / 100,
        [-5]: 36 / 100,
        [-4]: 43 / 100,
        [-3]: 50 / 100,
        [-2]: 60 / 100,
        [-1]: 75 / 100,
        [0]: 100 / 100,
        [1]: 133 / 100,
        [2]: 166 / 100,
        [3]: 200 / 100,
        [4]: 250 / 100,
        [5]: 266 / 100,
        [6]: 300 / 100,
    },
    evasiveness: {
        [6]: 33 / 100,
        [5]: 36 / 100,
        [4]: 43 / 100,
        [3]: 50 / 100,
        [2]: 60 / 100,
        [1]: 75 / 100,
        [0]: 100 / 100,
        [-1]: 133 / 100,
        [-2]: 166 / 100,
        [-3]: 200 / 100,
        [-4]: 250 / 100,
        [-5]: 266 / 100,
        [-6]: 300 / 100,
    },
    general: {
        [-6]: 2 / 8,
        [-5]: 2 / 7,
        [-4]: 2 / 6,
        [-3]: 2 / 5,
        [-2]: 2 / 4,
        [-1]: 2 / 3,
        [0]: 2 / 2,
        [1]: 3 / 2,
        [2]: 4 / 2,
        [3]: 5 / 2,
        [4]: 6 / 2,
        [5]: 7 / 2,
        [6]: 8 / 2,
    },
};

// Healing items
export const healingItemIDs = [
    'potion',
    'super_potion',
    'hyper_potion',
    'max_potion',
    'antidote',
    'paralyze_heal',
    'burn_heal',
    'ice_heal',
    'awakening',
    'full_restore',
    'full_heal',
    'revive',
    'max_revive',
    'elixir',
    'max_elixir',
    'rare_candy',
];

// Type effectiveness chart
export const typeEffectiveness = {
    normal: { rock: 0.5, ghost: 0, steel: 0.5 },
    fire: { fire: 0.5, water: 0.5, grass: 2, ice: 2, bug: 2, rock: 0.5, dragon: 0.5, steel: 2 },
    water: { fire: 2, water: 0.5, grass: 0.5, ground: 2, rock: 2, dragon: 0.5 },
    electric: { water: 2, electric: 0.5, grass: 0.5, ground: 0, flying: 2, dragon: 0.5 },
    grass: {
        fire: 0.5,
        water: 2,
        grass: 0.5,
        poison: 0.5,
        ground: 2,
        flying: 0.5,
        bug: 0.5,
        rock: 2,
        dragon: 0.5,
        steel: 0.5,
    },
    ice: { fire: 0.5, water: 0.5, grass: 2, ice: 0.5, ground: 2, flying: 2, dragon: 2, steel: 0.5 },
    fighting: {
        normal: 2,
        ice: 2,
        poison: 0.5,
        flying: 0.5,
        psychic: 0.5,
        bug: 0.5,
        rock: 2,
        ghost: 0,
        dark: 2,
        steel: 2,
        fairy: 0.5,
    },
    poison: { grass: 2, poison: 0.5, ground: 0.5, rock: 0.5, ghost: 0.5, steel: 0, fairy: 2 },
    ground: { fire: 2, electric: 2, grass: 0.5, poison: 2, flying: 0, bug: 0.5, rock: 2, steel: 2 },
    flying: { electric: 0.5, grass: 2, fighting: 2, bug: 2, rock: 0.5, steel: 0.5 },
    psychic: { fighting: 2, poison: 2, psychic: 0.5, dark: 0, steel: 0.5 },
    bug: {
        fire: 0.5,
        grass: 2,
        fighting: 0.5,
        poison: 0.5,
        flying: 0.5,
        psychic: 2,
        ghost: 0.5,
        dark: 2,
        steel: 0.5,
        fairy: 0.5,
    },
    rock: { fire: 2, ice: 2, fighting: 0.5, ground: 0.5, flying: 2, bug: 2, steel: 0.5 },
    ghost: { normal: 0, psychic: 2, ghost: 2, dark: 0.5 },
    dragon: { dragon: 2, steel: 0.5, fairy: 0 },
    dark: { fighting: 0.5, psychic: 2, ghost: 2, dark: 0.5, fairy: 0.5 },
    steel: { fire: 0.5, water: 0.5, electric: 0.5, ice: 2, rock: 2, steel: 0.5, fairy: 2 },
    fairy: { fire: 0.5, fighting: 2, poison: 0.5, dragon: 2, dark: 2, steel: 0.5 },
};

export const fontPixelMap = {
    a: ['00000', '00000', '00000', '01111', '10001', '10001', '10011', '01101', '00000', '00000'],
    b: ['10000', '10000', '10000', '11110', '10001', '10001', '10001', '11110', '00000', '00000'],
    c: ['00000', '00000', '00000', '01110', '10001', '10000', '10001', '01110', '00000', '00000'],
    d: ['00001', '00001', '00001', '01111', '10001', '10001', '10001', '01111', '00000', '00000'],
    e: ['00000', '00000', '00000', '01110', '10001', '11111', '10000', '01111', '00000', '00000'],
    f: ['00110', '01000', '01000', '11110', '01000', '01000', '01000', '01000', '00000', '00000'],
    g: ['00000', '00000', '00000', '01110', '10001', '10001', '10001', '01111', '00001', '01110'],
    h: ['10000', '10000', '10000', '11110', '10001', '10001', '10001', '10001', '00000', '00000'],
    i: ['00100', '00000', '00000', '00100', '00100', '00100', '00100', '00100', '00000', '00000'],
    j: ['00010', '00000', '00000', '00010', '00010', '00010', '00010', '00010', '10010', '01100'],
    k: ['10000', '10000', '10000', '10010', '10100', '11000', '10100', '10010', '00000', '00000'],
    l: ['01100', '00100', '00100', '00100', '00100', '00100', '00100', '00100', '00000', '00000'],
    m: ['00000', '00000', '00000', '11110', '10101', '10101', '10101', '10101', '00000', '00000'],
    n: ['00000', '00000', '00000', '11100', '10010', '10010', '10010', '10010', '00000', '00000'],
    o: ['00000', '00000', '00000', '01110', '10001', '10001', '10001', '01110', '00000', '00000'],
    p: ['00000', '00000', '00000', '11110', '10001', '10001', '10001', '11110', '10000', '10000'],
    q: ['00000', '00000', '00000', '01111', '10001', '10001', '10001', '01111', '00001', '00001'],
    r: ['00000', '00000', '00000', '10110', '11000', '10000', '10000', '10000', '00000', '00000'],
    s: ['00000', '00000', '00000', '11110', '10000', '01100', '00010', '11110', '00000', '00000'],
    t: ['00000', '01000', '01000', '11110', '01000', '01000', '01000', '01110', '00000', '00000'],
    u: ['00000', '00000', '00000', '10010', '10010', '10010', '10010', '01101', '00000', '00000'],
    v: ['00000', '00000', '00000', '10001', '10001', '01010', '01010', '00100', '00000', '00000'],
    w: ['00000', '00000', '00000', '10101', '10101', '10101', '10101', '01010', '00000', '00000'],
    x: ['00000', '00000', '00000', '10001', '01010', '00100', '01010', '10001', '00000', '00000'],
    y: ['00000', '00000', '00000', '10001', '10001', '10001', '10001', '01111', '00001', '11110'],
    z: ['00000', '00000', '00000', '11111', '00010', '00100', '01000', '11111', '00000', '00000'],
    ' ': ['00000', '00000', '00000', '00000', '00000', '00000', '00000', '00000', '00000', '00000'],
};

export const fontPixelMapV2 = {
    a: ['00000', '00000', '00000', '01111', '10001', '10001', '10011', '01101', '00000', '00000'],
    b: ['10000', '10000', '10000', '11110', '10001', '10001', '10001', '11110', '00000', '00000'],
    c: ['00000', '00000', '00000', '01110', '10001', '10000', '10001', '01110', '00000', '00000'],
    d: ['00001', '00001', '00001', '01111', '10001', '10001', '10001', '01111', '00000', '00000'],
    e: ['00000', '00000', '00000', '01110', '10001', '11111', '10000', '01111', '00000', '00000'],
    é: ['00010', '00100', '00000', '01110', '10001', '11111', '10000', '01111', '00000', '00000'],
    f: ['00110', '01000', '01000', '11110', '01000', '01000', '01000', '01000', '00000', '00000'],
    g: ['00000', '00000', '00000', '01110', '10001', '10001', '10001', '01111', '00001', '01110'],
    h: ['10000', '10000', '10000', '11110', '10001', '10001', '10001', '10001', '00000', '00000'],
    i: ['01000', '00000', '00000', '01000', '01000', '01000', '01000', '01000', '00000', '00000'],
    j: ['00010', '00000', '00000', '00010', '00010', '00010', '00010', '10010', '10010', '01100'],
    k: ['10000', '10000', '10000', '10010', '10100', '11000', '10100', '10010', '00000', '00000'],
    l: ['11000', '01000', '01000', '01000', '01000', '01000', '01000', '01000', '00000', '00000'],
    m: ['00000', '00000', '00000', '11110', '10101', '10101', '10101', '10101', '00000', '00000'],
    n: ['00000', '00000', '00000', '11100', '10010', '10010', '10010', '10010', '00000', '00000'],
    o: ['00000', '00000', '00000', '01110', '10001', '10001', '10001', '01110', '00000', '00000'],
    p: ['00000', '00000', '00000', '11110', '10001', '10001', '10001', '11110', '10000', '10000'],
    q: ['00000', '00000', '00000', '01111', '10001', '10001', '10001', '01111', '00001', '00001'],
    r: ['00000', '00000', '00000', '10110', '11000', '10000', '10000', '10000', '00000', '00000'],
    s: ['00000', '00000', '00000', '11110', '10000', '01100', '00010', '11110', '00000', '00000'],
    t: ['00000', '01000', '01000', '11110', '01000', '01000', '01000', '01110', '00000', '00000'],
    u: ['00000', '00000', '00000', '10010', '10010', '10010', '10010', '01101', '00000', '00000'],
    v: ['00000', '00000', '00000', '10001', '10001', '01010', '01010', '00100', '00000', '00000'],
    w: ['00000', '00000', '00000', '10101', '10101', '10101', '10101', '01010', '00000', '00000'],
    x: ['00000', '00000', '00000', '10001', '01010', '00100', '01010', '10001', '00000', '00000'],
    y: ['00000', '00000', '00000', '10001', '10001', '10001', '10001', '01111', '00001', '11110'],
    z: ['00000', '00000', '00000', '11111', '00010', '00100', '01000', '11111', '00000', '00000'],
    A: ['01110', '10001', '10001', '10001', '11111', '10001', '10001', '10001', '00000', '00000'],
    B: ['11110', '10001', '10001', '11110', '10001', '10001', '10001', '11110', '00000', '00000'],
    C: ['01110', '10001', '10000', '10000', '10000', '10000', '10001', '01110', '00000', '00000'],
    D: ['11110', '10001', '10001', '10001', '10001', '10001', '10001', '11110', '00000', '00000'],
    E: ['11111', '10000', '10000', '11110', '10000', '10000', '10000', '11111', '00000', '00000'],
    F: ['11111', '10000', '10000', '11110', '10000', '10000', '10000', '10000', '00000', '00000'],
    G: ['01110', '10001', '10001', '10000', '10011', '10001', '10001', '01110', '00000', '00000'],
    H: ['10001', '10001', '10001', '11111', '10001', '10001', '10001', '10001', '00000', '00000'],
    I: ['11111', '00100', '00100', '00100', '00100', '00100', '00100', '11111', '00000', '00000'],
    J: ['00001', '00001', '00001', '00001', '00001', '00001', '10001', '01110', '00000', '00000'],
    K: ['10001', '10010', '10100', '11000', '11000', '10100', '10010', '10001', '00000', '00000'],
    L: ['10000', '10000', '10000', '10000', '10000', '10000', '10000', '11111', '00000', '00000'],
    M: ['10001', '11011', '11011', '10101', '10101', '10001', '10001', '10001', '00000', '00000'],
    N: ['10001', '11001', '11001', '10101', '10011', '10011', '10001', '10001', '00000', '00000'],
    O: ['01110', '10001', '10001', '10001', '10001', '10001', '10001', '01110', '00000', '00000'],
    P: ['11110', '10001', '10001', '10001', '11110', '10000', '10000', '10000', '00000', '00000'],
    Q: ['01110', '10001', '10001', '10001', '10001', '11101', '10010', '01101', '00000', '00000'],
    R: ['11110', '10001', '10001', '10001', '11110', '10010', '10001', '10001', '00000', '00000'],
    S: ['01110', '10001', '10000', '01100', '00010', '00001', '10001', '01110', '00000', '00000'],
    T: ['11111', '00100', '00100', '00100', '00100', '00100', '00100', '00100', '00000', '00000'],
    U: ['10001', '10001', '10001', '10001', '10001', '10001', '10001', '01110', '00000', '00000'],
    V: ['10001', '10001', '10001', '10001', '01010', '01010', '00100', '00100', '00000', '00000'],
    W: ['10001', '10001', '10101', '10101', '10101', '11011', '11011', '10001', '00000', '00000'],
    X: ['10001', '10001', '01010', '00100', '00100', '01010', '10001', '10001', '00000', '00000'],
    Y: ['10001', '10001', '01010', '01010', '00100', '00100', '00100', '00100', '00000', '00000'],
    Z: ['11111', '00001', '00010', '00100', '00100', '01000', '10000', '11111', '00000', '00000'],
    '.': ['00000', '00000', '00000', '00000', '00000', '00000', '01100', '01100', '00000', '00000'],
    ',': ['00000', '00000', '00000', '00000', '00000', '00000', '01100', '01100', '00100', '01000'],
    0: ['01110', '10001', '10001', '10001', '10001', '10001', '10001', '10001', '01110', '00000'],
    1: ['00100', '01100', '00100', '00100', '00100', '00100', '00100', '00100', '01110', '00000'],
    2: ['01110', '10001', '10001', '00001', '00010', '00100', '01000', '10000', '11111', '00000'],
    3: ['01110', '10001', '00001', '00001', '00110', '00001', '00001', '10001', '01110', '00000'],
    4: ['00110', '01010', '01010', '10010', '10010', '10010', '11111', '00010', '00010', '00000'],
    5: ['11111', '10000', '10000', '10000', '11110', '00001', '00001', '10001', '01110', '00000'],
    6: ['01110', '10001', '10000', '10000', '11110', '10001', '10001', '10001', '01110', '00000'],
    7: ['11111', '00001', '00001', '00001', '00010', '00010', '00100', '00100', '00100', '00000'],
    8: ['01110', '10001', '10001', '10001', '01110', '10001', '10001', '10001', '01110', '00000'],
    9: ['01110', '10001', '10001', '10001', '01111', '00001', '00001', '10001', '01110', '00000'],
    '!': ['00000', '01110', '01110', '00100', '00100', '00000', '00000', '00100', '00000', '00000'],
    '?': ['00000', '01100', '10010', '00010', '01100', '01000', '00000', '01000', '00000', '00000'],
    '♂': ['00100', '01110', '10101', '00100', '00100', '01110', '10001', '10001', '10001', '01110'],
    '♀': ['01110', '10001', '10001', '10001', '01110', '00100', '11111', '00100', '00100', '00100'],
    '/': ['00001', '00001', '00010', '00010', '00100', '00100', '01000', '01000', '10000', '10000'],
    '-': ['00000', '00000', '00000', '11111', '00000', '00000', '00000', '00000', '00000', '00000'],
    ellipsis: ['00000', '00000', '00000', '00000', '00000', '10101', '00000', '00000', '00000', '00000'],
    '“': ['01001', '10010', '11011', '11011', '00000', '00000', '00000', '00000', '00000', '00000'],
    '”': ['11011', '11011', '01001', '10010', '00000', '00000', '00000', '00000', '00000', '00000'],
    '‘': ['00100', '01000', '01100', '01100', '00000', '00000', '00000', '00000', '00000', '00000'],
    '’': ['01100', '01100', '00100', '01000', '00000', '00000', '00000', '00000', '00000', '00000'],
    "'": ['01100', '01100', '00100', '01000', '00000', '00000', '00000', '00000', '00000', '00000'],
    '\u20BD': ['01110', '01001', '01001', '01110', '01000', '11110', '01000', '11110', '01000'],
    ':': ['00000', '00000', '01100', '01100', '00000', '01100', '01100', '00000', '00000'],
    '↑': ['00000', '00100', '01110', '11111', '01110', '01110', '01110', '00000'],
    '↓': ['00000', '01110', '01110', '01110', '11111', '01110', '00100', '00000'],
    '←': ['000000', '000000', '001000', '011111', '111111', '011111', '001000', '000000'],
    '→': ['000000', '000000', '000100', '111110', '111111', '111110', '000100', '000000'],
    '%': ['01100000', '10010010', '10010100', '01101000', '00010110', '00101001', '01001001', '00000110']
};

export const fontPixelMapSmall = {
    a: ['0000', '0000', '0111', '1001', '1001', '1011', '0101', '0000'],
    b: ['1000', '1000', '1110', '1001', '1001', '1001', '1110', '0000'],
    c: ['0000', '0000', '0110', '1001', '1000', '1001', '0110', '0000'],
    d: ['0001', '0001', '0111', '1001', '1001', '1001', '0111', '0000'],
    e: ['0000', '0000', '0110', '1001', '1111', '1000', '0111', '0000'],
    é: ['0011', '0000', '0110', '1001', '1111', '1000', '0111', '0000'],
    f: ['0011', '0100', '1110', '0100', '0100', '0100', '0100', '0000'],
    g: ['0000', '0000', '0111', '1001', '1001', '0111', '0001', '0110'],
    h: ['1000', '1000', '1110', '1001', '1001', '1001', '1001', '0000'],
    i: ['1000', '0000', '1000', '1000', '1000', '1000', '1000', '0000'],
    j: ['0010', '0000', '0010', '0010', '0010', '0010', '1100', '0000'],
    k: ['1000', '1000', '1001', '1010', '1100', '1010', '1001', '0000'],
    l: ['1100', '0100', '0100', '0100', '0100', '0100', '0100', '0000'],
    m: ['0000', '0000', '1010', '1101', '1101', '1101', '1101', '0000'],
    n: ['0000', '0000', '1110', '1001', '1001', '1001', '1001', '0000'],
    o: ['0000', '0000', '0110', '1001', '1001', '1001', '0110', '0000'],
    p: ['0000', '0000', '1110', '1001', '1001', '1110', '1000', '1000'],
    q: ['0000', '0000', '0111', '1001', '1001', '0111', '0001', '0001'],
    r: ['0000', '0000', '1011', '1100', '1000', '1000', '1000', '0000'],
    s: ['0000', '0000', '0111', '1000', '0110', '0001', '1110', '0000'],
    t: ['0000', '0100', '1111', '0100', '0100', '0100', '0011', '0000'],
    u: ['0000', '0000', '1001', '1001', '1001', '1011', '0101', '0000'],
    v: ['0000', '0000', '1001', '1001', '1001', '1010', '0100', '0000'],
    w: ['0000', '0000', '1001', '1001', '1001', '1111', '1001', '0000'],
    x: ['0000', '0000', '1001', '1001', '0110', '1001', '1001', '0000'],
    y: ['0000', '0000', '1001', '1001', '1001', '0111', '0001', '0110'],
    z: ['0000', '0000', '1111', '0001', '0010', '0100', '1111', '0000'],
    A: ['0110', '1001', '1001', '1111', '1001', '1001', '1001', '0000'],
    B: ['1110', '1001', '1001', '1110', '1001', '1001', '1110', '0000'],
    C: ['0110', '1001', '1000', '1000', '1000', '1001', '0110', '0000'],
    D: ['1110', '1001', '1001', '1001', '1001', '1001', '1110', '0000'],
    E: ['1111', '1000', '1000', '1110', '1000', '1000', '1111', '0000'],
    F: ['1111', '1000', '1000', '1110', '1000', '1000', '1000', '0000'],
    G: ['0110', '1001', '1000', '1011', '1001', '1001', '0110', '0000'],
    H: ['1001', '1001', '1001', '1111', '1001', '1001', '1001', '0000'],
    I: ['1110', '0100', '0100', '0100', '0100', '0100', '1110', '0000'],
    J: ['0001', '0001', '0001', '0001', '1001', '1001', '0110', '0000'],
    K: ['1001', '1001', '1010', '1100', '1010', '1001', '1001', '0000'],
    L: ['1000', '1000', '1000', '1000', '1000', '1000', '1111', '0000'],
    M: ['1001', '1111', '1001', '1001', '1001', '1001', '1001', '0000'],
    N: ['1001', '1101', '1101', '1011', '1011', '1001', '1001', '0000'],
    O: ['0110', '1001', '1001', '1001', '1001', '1001', '0110', '0000'],
    P: ['1110', '1001', '1001', '1110', '1000', '1000', '1000', '0000'],
    Q: ['0110', '1001', '1001', '1001', '1001', '1011', '0110', '0001'],
    R: ['1110', '1001', '1001', '1110', '1001', '1001', '1001', '0000'],
    S: ['0110', '1001', '1000', '0110', '0001', '1001', '0110', '0000'],
    T: ['1110', '0100', '0100', '0100', '0100', '0100', '0100', '0000'],
    U: ['1001', '1001', '1001', '1001', '1001', '1001', '0110', '0000'],
    V: ['1001', '1001', '1001', '1001', '1001', '1010', '0100', '0000'],
    W: ['1001', '1001', '1001', '1001', '1001', '1111', '1001', '0000'],
    X: ['1001', '1001', '1001', '0110', '1001', '1001', '1001', '0000'],
    Y: ['1010', '1010', '1010', '1010', '0100', '0100', '0100', '0000'],
    Z: ['1111', '0001', '0010', '0010', '0100', '0100', '1111', '0000'],
    '.': ['0000', '0000', '0000', '0000', '0000', '1100', '1100', '0000'],
    ',': ['0000', '0000', '0000', '0000', '0000', '1100', '1100', '0100'],
    ':': ['0000', '0000', '0110', '0110', '0000', '0110', '0110', '0000'],
    0: ['0110', '1001', '1001', '1001', '1001', '1001', '0110', '0000'],
    1: ['0100', '1100', '0100', '0100', '0100', '0100', '1110', '0000'],
    2: ['0110', '1001', '0001', '0010', '0100', '1000', '1111', '0000'],
    3: ['0110', '1001', '0001', '0110', '0001', '1001', '0110', '0000'],
    4: ['0110', '1010', '1010', '1010', '1010', '1111', '0010', '0000'],
    5: ['1111', '1000', '1000', '1110', '0001', '1001', '0110', '0000'],
    6: ['0110', '1001', '1000', '1110', '1001', '1001', '0110', '0000'],
    7: ['1111', '0001', '0001', '0010', '0010', '0100', '0100', '0000'],
    8: ['0110', '1001', '1001', '0110', '1001', '1001', '0110', '0000'],
    9: ['0110', '1001', '1001', '0111', '0001', '1001', '0110', '0000'],
    '!': ['0100', '0100', '0100', '0100', '0100', '0000', '0100', '0000'],
    '?': ['0110', '1001', '0001', '0010', '0010', '0000', '0010', '0000'],
    '♂': ['0010', '0111', '1010', '0110', '1001', '1001', '0110', '0000'],
    '♀': ['0110', '1001', '1001', '0110', '0010', '1111', '0010', '0000'],
    '/': ['0001', '0001', '0010', '0010', '0100', '0100', '1000', '1000'],
    '-': ['0000', '0000', '0000', '0000', '1111', '0000', '0000', '0000'],
    '+': ['0000', '0000', '0100', '1110', '0100', '0000', '0000', '0000'],
    '<': ['0000', '0000', '0000', '0000', '0000', '0000', '1001', '0000'],
    '>': ['0101', '1010', '1111', '0000', '0000', '0000', '0000', '0000'],
    '"': ['0100', '1000', '1100', '0000', '0000', '0000', '0000', '0000'],
    "'": ['1100', '0100', '1000', '0000', '0000', '0000', '0000', '0000'],
    '\u20BD': ['0110', '0101', '0101', '0110', '1110', '0100', '1110', '0100'],
    '@': ['0110', '1001', '1011', '1101', '1101', '1011', '1000', '0111'],
    '|': ['1000', '1000', '1000', '1000', '1000', '1000', '1000', '1000'],
    // Arrows: 5×8 so they render fully in small font (variable-width)
    '↑': ['00000', '00100', '01110', '11111', '01110', '01110', '01110', '00000'],
    '↓': ['00000', '01110', '01110', '01110', '11111', '01110', '00100', '00000'],
    '←': ['000000', '000000', '001000', '011111', '111111', '011111', '001000', '000000'],
    '→': ['000000', '000000', '000100', '111110', '111111', '111110', '000100', '000000'],
    '%': ['00000', '11001', '11010', '00100', '01011', '10011', '00000', '00000'],
};
